import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import UserList from '../../lists/UserList/UserList';

const DialogPublishResults = ({ t, open, onClose, users, onSuccess, onChangeUsersToPublish, showCheckbox, showPoints, evaluationScale }) => {
  return (
    <Dialog
      title={t('Publish assessment results')}
      isOpen={open}
      className={'dialog-publish-results'}
      size="l"
      text={t('The selected students will see their grades when you publish them')}
      hasSeparator={true}
      buttonTextSuccess={t('Publish')}
      buttonTextCancel={t('Not yet')}
      onClose={onClose}
      onSuccess={onSuccess}
      onCancel={onClose}
    >
      <div className="dialog-publish-results__content">
        <UserList
          users={users}
          legend={showCheckbox ? t('Publish assessment results') : undefined}
          isLegendHidden
          isScoreReadOnly={true}
          usersDefaultSelected={users}
          onChangeSelection={onChangeUsersToPublish}
          showPoints={showPoints}
          showCheckbox={showCheckbox}
          evaluationScale={evaluationScale}
        />
      </div>
    </Dialog>
  );
};

DialogPublishResults.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  code: PropTypes.string,
  name: PropTypes.string,
  level: PropTypes.string,
  evaluationScale: PropTypes.object,
  onChangeUsersToPublish: PropTypes.func,
  onSuccess: PropTypes.func,
  showCheckbox: PropTypes.bool,
  showPoints: PropTypes.bool,
  t: PropTypes.func,
  users: PropTypes.array,
};

DialogPublishResults.defaultProps = {
  onClose: function () {},
  open: false,
};

export default withTranslation(['assigments', 'common'])(DialogPublishResults);
